module.exports = __webpack_public_path__ + "img/double-image-hero-mitsubishi.bd06968c.png";